module.exports = {"TXTCLI_Probability_1M":{"id":"TXTCLI_Probability_1M","defaultMessage":"確率 (100 万分の X)","track":"Probability/1M"}}